// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__pD3mV","box":"WorkspacesBox_box__3hFck","node":"WorkspacesBox_node__1q-TH"};